import colors from 'vuetify/es5/util/colors'
// import Vue from 'vue'

export default {
  theme1: {
    darkMode: true,
    themes: {
      light: {
        primary: '#556cd6',
        secondary: '#ff0000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        // My own variables
        color1: '#3A66FF',
        color2: '#b84c99',
        icon: {
          // base: '#5f6368' // Google keep icon color
          base: '#5f6368'
        },
        text: {
          base: '#3c4043',
        },
        textSecondary: {
          base: '#9EA4AA',
        },
        txtlabel: {
          base: "#555",
        },
        activeField: {
          base: '#b3cefb'
        },
        background: {
          base: '#e3e8ee'
        },
        backgroundCard: {
          base: '#f7fafc'
        },
        foreground: {
          base: '#fff'
        },
        background2: {
          base: '#1c1b20' // page
        },
        backgroundHover: {
          base: "#f7fafc"
        },
        menuBackground: {
          base: '#fff'
        },
        menuText: {
          base: '#222'
        },
        hline: {
          base: '#e3e8ee'
        },
        // backgroundNav: '#222126',
        backgroundNav: '#242424',
        textNav: {
          /* base: '#636368',
          lighten1: '#FFF' */
          base: '#fafafa',
          lighten1: '#444'
        },
        navIcon: '#fff',
        scrollThumb: {
          base: '#ff0000'
        },
        scrollTrack: {
          base: '#00ff00'
        },
        boxShadow: {
          base: '#000000'
        }
      },
      dark: {
        primary: '#556cd6',
        secondary: '#ff0000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        // My own variables
        color1: '#1697F6',
        color2: '#b84c99',
        icon: {
          // base: '#5f6368' // Google keep icon color
          base: '#b4beca'
        },
        text: {
          base: '#eceef6',
        },
        textSecondary: {
          base: '#ccc',
        },
        txtlabel: {
          base: "#aaa",
        },
        activeField: {
          base: '#b3cefb'
        },
        background: {
          base: '#1d1e26'
        },
        backgroundCard: {
          base: '#262932'
        },
        foreground: {
          base: '#323846'
        },
        background2: {
          base: '#1c1b20' // page
        },
        backgroundHover: {
          base: "#414754"
        },
        menuBackground: {
          base: '#fff'
        },
        menuText: {
          base: '#222'
        },
        hline: {
          base: '#3e404c'
        },
        backgroundNav: '#323846',
        textNav: {
          base: '#b4beca'
        },
        navIcon: '#b4beca',
        scrollThumb: {
          base: '#788298'
        },
        scrollTrack: {
          base: '#262932'
        },
        boxShadow: {
          base: '#000000'
        }
      }
    }
  },
  theme2: {
    darkMode: true,
    themes: {
      light: {
        primary: '#556cd6',
        secondary: '#ff0000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        // My own variables
        color1: '#E50914',
        color2: '#b84c99',
        icon: {
          // base: '#5f6368' // Google keep icon color
          base: '#5f6368'
        },
        text: {
          base: '#3c4043',
        },
        textSecondary: {
          base: '#9EA4AA',
        },
        txtlabel: {
          base: "#555",
        },
        activeField: {
          base: '#b3cefb'
        },
        background: {
          base: '#fff'
        },
        backgroundCard: {
          base: '#fff'
        },
        foreground: {
          base: '#fff'
        },
        background2: {
          base: '#1c1b20' // page
        },
        backgroundHover: {
          base: "#f7fafc"
        },
        menuBackground: {
          base: '#fff'
        },
        menuText: {
          base: '#222'
        },
        hline: {
          base: '#e3e8ee'
        },
        // backgroundNav: '#222126',
        backgroundNav: '#fff',
        textNav: {
          /* base: '#636368',
          lighten1: '#FFF' */
          base: '#222',
          lighten1: '#444'
        },
        navIcon: '#fff',
        scrollThumb: {
          base: '#ff0000'
        },
        scrollTrack: {
          base: '#00ff00'
        },
        boxShadow: {
          base: '#000000'
        }
      },
      dark: {
        primary: '#556cd6',
        secondary: '#ff0000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        // My own variables
        color1: '#1697F6',
        color2: '#b84c99',
        icon: {
          // base: '#5f6368' // Google keep icon color
          base: '#9d9d9d'
        },
        text: {
          base: '#eceef6',
        },
        textSecondary: {
          base: '#aaa',
        },
        txtlabel: {
          base: "#999",
        },
        activeField: {
          base: '#b3cefb'
        },
        background: {
          base: '#1F1F1F'
        },
        backgroundCard: {
          base: '#6F6F6F'
        },
        foreground: {
          // base: '#424242'
          base: '#1F1F1F'
        },
        background2: {
          base: '#1F1F1F' // page
        },
        backgroundHover: {
          base: "#6F6F6F"
        },
        menuBackground: {
          base: '#fff'
        },
        menuText: {
          base: '#222'
        },
        hline: {
          base: '#333333'
        },
        backgroundNav: '#282828',
        textNav: {
          base: '#b4beca'
        },
        navIcon: '#b4beca',
        scrollThumb: {
          base: '#788298'
        },
        scrollTrack: {
          base: '#3c4352'
        },
        boxShadow: {
          base: '#000000'
        }
      }
    }
  }
}
